import '@forest/shared/polyfills'

// Must stay a static import: it installs the native bridge handler and arms the
// loading deadline before native sends pageVisible.
import './setup'

import { render } from 'solid-js/web'
import '~/styles/global.css'
import { App } from './app'

render(() => <App />, document.getElementById('root')!)
